export default __webpack_public_path__ + "static/media/twitter.27cda7bd.png";